import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages, formatStyleTrakerOptions } from '@/features/filter/static/filterUtil';

import MultiLayerFilter from '../../Common/MultiLayerFilter';

const StyleTraker = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.STYLE_TRACKER]: dependentFilterList?.taskGroupList
	};

	const onFetchData = async () => {
		let dependentList = filterData[filterPageName];

		const options = formatStyleTrakerOptions(dependentList || []);
		setAllData(options);
		setData(options);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type="STYLE_TRACKER"
			isOpenFourthLayerOnSearch={false}
			isShowCalander={true}
		/>
	);
};

export default StyleTraker;
